<script lang="ts">
  import { Route } from "svelte-navigator";
  import pageUrl from "./PageUrl";
  import Home from "./pages/Home.svelte";
  import BlogList from "./pages/blog/BlogList.svelte";
  import BlogPost from "./pages/blog/BlogPost.svelte";
  import Careers from "./pages/Careers.svelte";
  import SignIn from "./pages/auth/SignIn.svelte";
  import SignOut from "./pages/auth/SignOut.svelte";
  import PasswordRecovery from "./pages/auth/reset-password/PasswordRecovery.svelte";
  import ResetPassword from "./pages/auth/reset-password/ResetPassword.svelte";
  import TwoFactorAuthentication from "./pages/auth/TwoFactorAuthentication.svelte";
  import CreateNewAccount from "./pages/auth/CreateNewAccount.svelte";
  import InternalAccessRoute from "./hocs/internal-access/InternalAccessRoute.svelte";
  import UserInfo from "./pages/UserInfo.svelte";
  import PageNotFound from "./components/fallback/PageNotFound.svelte";
  import PrivateRouteGuard from "./hocs/PrivateRouteGuard.svelte";
  import InvisibleOnLoggedIn from "./hocs/InvisibleOnLoggedIn.svelte";
  import RedirectToUiPageOnLoggedIn from "./hocs/RedirectToUiPageOnLoggedIn.svelte";
</script>

<Route path={pageUrl.HOME}>
  <RedirectToUiPageOnLoggedIn>
    <Home />
  </RedirectToUiPageOnLoggedIn>
</Route>

<Route path={pageUrl.BLOG}>
  <BlogList />
</Route>

<Route path={`${pageUrl.BLOG}/:id`} let:params={p}>
  <BlogPost blogId={p.id} />
</Route>

<Route path={pageUrl.CAREERS}>
  <Careers />
</Route>

<InternalAccessRoute path={pageUrl.SIGNIN}>
  <RedirectToUiPageOnLoggedIn>
    <InvisibleOnLoggedIn>
      <SignIn />
    </InvisibleOnLoggedIn>
  </RedirectToUiPageOnLoggedIn>
</InternalAccessRoute>

<InternalAccessRoute path={pageUrl.SIGNOUT}>
  <SignOut />
</InternalAccessRoute>

<InternalAccessRoute path={pageUrl.REGISTER}>
  <RedirectToUiPageOnLoggedIn>
    <InvisibleOnLoggedIn>
      <CreateNewAccount />
    </InvisibleOnLoggedIn>
  </RedirectToUiPageOnLoggedIn>
</InternalAccessRoute>

<InternalAccessRoute path={pageUrl.PASSWORD_RECOVERY}>
  <RedirectToUiPageOnLoggedIn>
    <PasswordRecovery />
  </RedirectToUiPageOnLoggedIn>
</InternalAccessRoute>

<InternalAccessRoute path={pageUrl.RESET_PASSWORD}>
  <RedirectToUiPageOnLoggedIn>
    <ResetPassword />
  </RedirectToUiPageOnLoggedIn>
</InternalAccessRoute>

<InternalAccessRoute path={pageUrl.TWOFACTOR_AUTHENTICATION}>
  <TwoFactorAuthentication />
</InternalAccessRoute>

<InternalAccessRoute path={pageUrl.USER_INFO}>
  <PrivateRouteGuard>
    <UserInfo />
  </PrivateRouteGuard>
</InternalAccessRoute>

<Route path="*">
  <RedirectToUiPageOnLoggedIn>
    <PageNotFound />
  </RedirectToUiPageOnLoggedIn>
</Route>
